module.exports = __webpack_public_path__ + "media/newstyle/images/word-message-aus-2a88faa707d2addfa1d00be3cc879c51.svg";